import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  volunteerLogin,
  volunteerStatus,
} from "../../lib/services/authService.js";
import eventLogo from "../../assets/eventLogo.png";

export default function EventLogin({
  isVolunteerAuthenticated,
  setIsVolunteerAuthenticated,
}) {
  const [inputCode, setInputCode] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const checkVolunteerStatus = async () => {
      const response = await volunteerStatus();
      if (response.ok) {
        const data = await response.json();
        setIsVolunteerAuthenticated(data.isAuthenticated);
      }
    };

    checkVolunteerStatus();
  }, []);

  useEffect(() => {
    if (!!isVolunteerAuthenticated) navigate("/volunteer/stencil-info");
  }, [isVolunteerAuthenticated, navigate]);

  const submit = async () => {
    const response = await volunteerLogin(inputCode);

    if (response.ok) {
      setIsVolunteerAuthenticated(true);
    } else {
      alert("Login failed");
    }
  };

  return (
    <div className="vol-wrap">
      <div className="vol-stack">
        {/* Brand logo above the card */}
        <img
          src={eventLogo}
          alt="Spirits in the Gardens"
          className="vol-logo"
          loading="eager"
        />

        {/* WHITE CARD */}
        <div className="vol-card">
          {" "}
          <>
            <h2 className="vol-title">Please Enter Event Access Code</h2>
            <span>Note: Code is case sensitive</span>
            <input
              className="vol-input"
              placeholder="Code"
              value={inputCode}
              onChange={(e) => setInputCode(e.target.value)}
              autoFocus
            />
            <button className="vol-btn primary mt-3" onClick={submit}>
              Submit
            </button>
          </>
        </div>
      </div>
    </div>
  );
}
